class TrieNode {
  private _letter: string | null;
  private _prevLetter: TrieNode | null;
  private _nextLetters: { [key: string]: TrieNode };
  private _isComplete: boolean;

  constructor(letter: string | null) {
    this._letter = letter;
    this._prevLetter = null;
    this._nextLetters = {};
    this._isComplete = false;
  }

  get letter(): string | null {
    return this._letter;
  }

  set letter(value: string | null) {
    this._letter = value;
  }

  get prevLetter(): TrieNode | null {
    return this._prevLetter;
  }

  set prevLetter(value: TrieNode | null) {
    this._prevLetter = value;
  }

  get nextLetters(): { [key: string]: TrieNode } {
    return this._nextLetters;
  }

  set nextLetters(value: { [key: string]: TrieNode }) {
    this._nextLetters = value;
  }

  get isComplete(): boolean {
    return this._isComplete;
  }

  set isComplete(value: boolean) {
    this._isComplete = value;
  }

  getWord(): string {
    let node: TrieNode | null = this;
    const wordLetters: string[] = [];
    while (node && node.prevLetter) {
      if (node.letter) wordLetters.unshift(node.letter);
      node = node.prevLetter;
    }
    return wordLetters.join("");
  }
}

class Trie {
  private _root: TrieNode;

  constructor() {
    this._root = new TrieNode(null);
  }

  get root(): TrieNode {
    return this._root;
  }

  set root(value: TrieNode) {
    this._root = value;
  }

  insert(word: string): void {
    let node = this.root;
    for (let i = 0; i < word.length; i++) {
      const currentLetter = word[i];
      if (!node.nextLetters[currentLetter]) {
        node.nextLetters[currentLetter] = new TrieNode(currentLetter);
        node.nextLetters[currentLetter].prevLetter = node;
      }
      node = node.nextLetters[currentLetter];
      if (i === word.length - 1) {
        node.isComplete = true;
      }
    }
  }

  contains(word: string): boolean {
    let node = this.root;
    for (let i = 0; i < word.length; i++) {
      const currentLetter = word[i];
      const nextNode = node.nextLetters[currentLetter];
      if (nextNode) {
        node = nextNode;
      } else {
        return false;
      }
    }
    return node.isComplete;
  }

  find(clueLetters: string): string[] {
    let node = this.root;
    const output: string[] = [];
    for (let i = 0; i < clueLetters.length; i++) {
      const clueLetter = clueLetters[i];
      const nextNode = node.nextLetters[clueLetter];
      if (nextNode) {
        node = nextNode;
      } else {
        return output;
      }
    }
    this.findAllWords(node, output);
    return output;
  }

  private findAllWords(node: TrieNode, arr: string[]): void {
    if (node.isComplete) {
      arr.unshift(node.getWord());
    }
    for (const nextLetter in node.nextLetters) {
      this.findAllWords(node.nextLetters[nextLetter], arr);
    }
  }
}

export default Trie;
